<template>
  <div class="sorttable">
    <div ref="caozuo">
      <el-button size="small" @click="dialogFormVisible">
        <i class="el-icon-plus"></i> 新增
      </el-button>
      <!-- <el-button size="small" @click="daoru">
        <i class="el-icon-plus"></i> 批量导入
      </el-button> -->
      <el-button size="small" @click="shuaxin">
        <i class="el-icon-refresh-right"></i> 刷新
      </el-button>
      <div style="float: right">
        <el-form
          :model="formes"
          style="height: 40px"
          :inline="true"
          label-width="90px"
        >
          <el-form-item label>
            <el-select
              v-model="select"
              placeholder="请选择"
              size="small"
              @change="switchover2"
              class="especially"
            >
              <el-option label="全部" value="1"></el-option>
              <el-option label="代理商" value="2"></el-option>
            </el-select>
            <!-- 关键字 -->
            <el-input
              @input="inputsearch"
              placeholder="关键字"
              size="small"
              v-model="formes.keywords"
              class="especially2"
              v-if="this.select == 1"
            >
              <i slot="suffix" class="el-input__icon el-icon-search"></i>
            </el-input>
            <!-- 代理商 -->
            <el-select
              v-model="formes.agent_id"
              @change="inputsearch"
              size="small"
              filterable
              class="especially2"
              v-if="this.select == 2"
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="(item, index) in agent_list"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <el-table
      :height="zhanshi"
      :data="tableData"
      style="width: 100%;margin-top:10px;"
      @row-click="particulars"
      :header-cell-style="headerCellStyle"
      :cell-style="cellStyle"
      ref="multipleTable"
    >
      <template slot="empty">
        <p style="text-align:center">暂无数据</p>
      </template>
      <el-table-column type="selection"></el-table-column>
      <el-table-column prop="id" label="代理商ID">
        <template slot-scope="scope">
          <span style="color: #67c23a">
            {{ scope.row.id ? scope.row.id : "xxx" }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="用户名"></el-table-column>
      <el-table-column prop="mobile" label="手机号码"></el-table-column>
      <!-- <el-table-column prop="level" label="代理商等级">
        <template slot-scope="scope">{{
          scope.row.level == 0
            ? "运营商"
            : scope.row.level == 1
            ? "一级代理商"
            : "二级代理商"
        }}</template>
      </el-table-column> -->
      <el-table-column prop="money" label="余额"> </el-table-column>
      <el-table-column prop="created_at" label="创建时间" sortable width="160">
      </el-table-column>
      <el-table-column
        prop="last_login_time"
        label="最后登录时间"
        sortable
        width="160"
      >
      </el-table-column>
      <el-table-column prop="login_ip" label="登录IP"></el-table-column>
      <el-table-column label="操作" width="250">
        <template slot-scope="scope">
          <div style="text-align:left;">
            <el-link
              type="primary"
              @click.native.stop="handleRecharge(scope.row)"
              >充值
            </el-link>
            <!-- <el-button
              size="mini"
              type="primary"
              plain
              @click.native.stop="getWebCname(scope.row)"
              >跳转</el-button
            > -->
            <span class="activespan">|</span>
            <el-link
              type="primary"
              @click.native.stop="handleKoukuan(scope.row)"
              >扣款
            </el-link>
            <span class="activespan">|</span>
            <el-link type="primary" @click.native.stop="handleEdit(scope.row)"
              >编辑
            </el-link>
            <span class="activespan">|</span>
            <el-link type="primary" @click.native.stop="getWebCname(scope.row)"
              >跳转
            </el-link>
            <!-- <el-link
              type="primary"
              @click.native.stop="handleDelete(scope.$index, scope.row)"
              >删除
            </el-link> -->
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <el-pagination
      class="pagination_bottom"
      background
      layout="total,sizes, prev, pager, next"
      :page-sizes="[20, 50, 100, 200, 300, 400]"
      @size-change="handleSizeChange"
      :total="total"
      :page-size="pagesize"
      @current-change="current_change"
      :current-page="currentPage"
    ></el-pagination>
    <!-- 详情侧滑 -->
    <el-drawer
      title="我是标题"
      :visible.sync="drawer"
      :with-header="false"
      :size="size"
    >
      <div class="head">
        <div class="head-l">
          <span>代理商</span>
          {{ row.name ? row.name : "暂无" }}
        </div>
        <div class="head-r">
          <button @click="handleEdit(row)">编辑</button>
          <span
            v-if="this.a == 2"
            @click="amplification(1)"
            class="el-icon-full-screen"
          ></span>
          <span
            v-if="this.a == 1"
            @click="amplification(2)"
            class="el-icon-aim"
          ></span>
          <span @click="close" class="el-icon-close"></span>
        </div>
      </div>
      <div class="main">
        <div class="detailed">
          <div>
            代理商ID
            <span>{{ row.active_code }}</span>
          </div>
          <div>
            用户名
            <span>{{ row.name }}</span>
          </div>
          <div>
            公司名称
            <span>{{ row.company_name }}</span>
          </div>
          <div>
            代理商等级
            <span>{{
              row.agent_level == 2 ? "二级代理商" : "一级代理商"
            }}</span>
          </div>
          <div>
            发展人
            <span>{{ row.develop_name }}</span>
          </div>
          <div>
            账号状态
            <span>{{ row.status == 0 ? "启用" : "禁用" }}</span>
          </div>
          <div>
            注册时间
            <span>{{ row.create_time | dateFormat }}</span>
          </div>
          <!-- <div>
            最后登录时间
            <span>
              {{ row.login_time | dateFormat }}
            </span>
          </div> -->
        </div>
        <div class="tab-control" v-if="drawer">
          <el-tabs v-model="activeName">
            <el-tab-pane label="认证信息" name="first">
              <Authentication :rowid="row.id"></Authentication>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </el-drawer>
    <!-- 详情侧滑 -->

    <router-view ref="Childmain"></router-view>

    <!-- 弹出层 -->
    <AgentAdd v-if="bolls" :msg="msg" @guan="guan"></AgentAdd>
    <Recharge ref="zuoqiAdd"></Recharge>
    <!-- 导入弹出层 -->
    <el-dialog
      title="导入"
      :visible.sync="dialogDaoruVisible"
      :destroy-on-close="true"
      width="500px"
      class="dialogbox"
    >
      <el-form :model="form3" ref="ruleForm2" label-width="80px">
        <el-form-item label="上传文件">
          <el-upload
            class="upload-demo"
            :action="this.hostName + '/UserController/ImportFileAction'"
            :on-success="handleSuccess"
            :on-error="handleError"
            :before-remove="beforeRemove"
            :before-upload="beforeUpload"
            multiple
            :limit="1"
            :on-exceed="handleExceed"
            :file-list="fileList"
            :auto-upload="true"
          >
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="导入模板">
          <span style="color: #26a7ff; cursor: pointer" @click="down"
            >点击下载模板</span
          >
        </el-form-item>
        <!-- <el-form-item label="并发">
          <el-input style="width: 50px" v-model="bingfa"></el-input>
        </el-form-item> -->
        <el-form-item label="说明">
          <span>每次导上限为3000条导入大量数据的情况下，请分批导入</span>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">导入</el-button>
          <el-button @click="dialogDaoruVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 导入弹出层 -->
  </div>
</template>

<script>
import { postData, getData } from "@/api";
import AgentAdd from "./newadd";
import axios from "axios";
import Recharge from "./recharge.vue";
import Authentication from "./authentication";
import { height1 } from "@/utils/height";
import { debounce } from "@/utils/tool.js";
export default {
  data() {
    return {
      zhanshi: "800px",
      select: "1",
      drawer: false,
      size: "70%",
      activeName: "first",
      row: {},
      a: 2,
      formes: {
        agent_id: "",
        fee_id: "",
        app_type: "",
        keywords: "",
        page: "",
        pagesize: 20,
      },
      agent_list: [],
      bolls: false,
      dialogTableVisible: false,
      //传到组件中的值
      msg: {},
      sousuo: "",
      jinyong: "",
      // 文件
      tableData: [],
      total: 0, //默认数据总数
      pagesize: 15, //每页的数据条数
      currentPage: 1, //默认开始页面
      dialogDaoruVisible: false,
      form3: {
        file: "",
        portal_id: "",
        company_id: "",
      },
      token: "",
      fileList: [],
      formData: new FormData(),
    };
  },
  created() {
    this.getMainData();
  },
  mounted() {
    setTimeout(() => {
      var H = document.body.clientHeight;
      this.zhanshi = H - height1;
    }, 100);
    const that = this;
    window.onresize = () => {
      var H = document.body.clientHeight;
      that.zhanshi = H - height1;
    };
  },
  methods: {
    inputsearch: debounce(function(e) {
      this.esarchang();
    }),
    // 下载导入模板
    down() {
      getData("UserController/demoAction").then((res) => {
        if (res.code !== 200) return this.$message.error(res.message);
        window.location.href = res.data;
      });
    },
    // 导入提交
    onSubmit() {
      if (this.formData.get("file") !== null) {
        let formData = new FormData();
        formData.append("file", this.formData.get("file"));
        axios
          .post(
            localStorage.getItem("service_cname") +
              "/agent" +
              "/UserController/ImportFileAction",
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
                token: sessionStorage.getItem("token"),
              },
            }
          )
          .then(({ data: res }) => {
            if (res.code !== 200) return this.$message.error(res.message);
            if (res.code == 200) {
              this.dialogDaoruVisible = false;
              this.$message.success("导入成功");
              this.getMainData();
            }
          });
      } else {
        this.$message({
          message: "请导入文件后提交",
          type: "error",
        });
      }
    },
    daoru() {
      this.dialogDaoruVisible = true;
    },
    //上传文件前的钩子
    beforeUpload(file) {
      this.formData.append("file", file);
    },
    // 上传成功
    handleSuccess(files) {
      this.form3.file = files.data.src;
    },
    // 上传失败
    handleError(files, fileList) {
      console.log(files, fileList);
    },
    // 数量超
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    //移除之前的钩子，清空所有文件
    beforeRemove() {
      this.formData = new FormData();
    },
    // 详情
    particulars(row) {
      this.drawer = true;
      this.row = row;
    },
    // 关闭侧滑
    close() {
      this.drawer = false;
      this.size = "70%";
      this.a = 2;
      this.formes = {
        agent_id: "",
        fee_id: "",
        app_type: "",
        keywords: "",
        page: "",
        pagesize: 20,
      };
      this.currentPage = 1;
      this.getMainData();
    },
    // 放大侧滑
    amplification(a) {
      this.a = a;
      if (a == 1) {
        this.size = "100%";
      } else {
        this.size = "70%";
      }
    },
    switchover2() {
      this.formes = { agent_id: "", fee_id: "", app_type: "", keywords: "" };
      this.currentPage = 1;
      this.esarchang();
    },
    //搜索
    esarchang() {
      this.formes.page = 1;
      postData("agent/agentListAction", this.formes).then((res) => {
        if (res.code !== 200) return this.$message.error(res.message);
        this.tableData = res.data.data;
        this.total = res.data.total;
        this.pagesize = res.data.per_page;
      });
    },
    //刷新
    shuaxin() {
      this.currentPage = 1;
      this.pagesize = 20;
      this.formes = { agent_id: "", fee_id: "", app_type: "", keywords: "" };
      this.getMainData();
      this.$message({ message: "刷新成功", type: "success" });
    },
    headerCellStyle() {
      return "text-align:left;background-color:#F2f2f2;";
    },
    cellStyle() {
      return "text-align:left;";
    },
    // 获取数据
    getMainData() {
      let params = {
        page: this.currentPage,
        role: 2,
        pagesize: 20,
      };
      getData("UserController/pageAction", params).then((res) => {
        if (res.code !== 200) return this.$message.error(res.message);
        this.tableData = res.data.data;
        this.total = res.data.total;
        this.pagesize = res.data.per_page;
      });
    },
    // 新增
    dialogFormVisible() {
      this.bolls = true;
      this.msg.bool = this.bolls;
      this.msg.title = "新增";
      this.msg.bianji = {};
    },
    guan(val) {
      this.rechargeVisible = val;
      this.bolls = val;
      this.msg.bianji = {};
    },
    // 编辑
    handleEdit(row) {
      this.bolls = true;
      this.msg.bool = this.bolls;
      this.msg.title = "编辑";
      this.msg.bianji = row;
    },
    //充值
    handleRecharge(row) {
      this.$refs.zuoqiAdd.dialogTableVisible = true;
      this.$refs.zuoqiAdd.form2.id = row.id;
      this.$refs.zuoqiAdd.name = row.name;
    },
    handleKoukuan(row) {
      this.$refs.zuoqiAdd.dialogTableVisiblekou = true;
      this.$refs.zuoqiAdd.form20.id = row.id;
      this.$refs.zuoqiAdd.name = row.name;
    },
    // 删除
    handleDelete(index, row) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          postData("agent/agentDelAction", { id: row.id }).then((res) => {
            if (res.code !== 200) return this.$message.error(res.message);
            this.$message.success(res.message);
            postData("agent/agentListAction", this.formes).then((res) => {
              if (res.code !== 200) return this.$message.error(res.message);
              this.tableData = res.data.data;
              this.total = res.data.total;
              this.pagesize = res.data.per_page;
            });
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 批量删除
    deletes() {},
    handleSizeChange(val) {
      this.formes.pagesize = val;
      this.esarchang();
    },
    // 分页
    current_change: function(currentPage) {
      this.formes.page = currentPage;
      this.currentPage = currentPage;
      postData("agent/agentListAction", this.formes).then((res) => {
        if (res.code !== 200) return this.$message.error(res.message);
        this.tableData = res.data.data;
        this.total = res.data.total;
        this.pagesize = res.data.per_page;
      });
    },
  },
  components: {
    AgentAdd,
    Recharge,
    Authentication,
  },
  watch: {
    $route() {
      setTimeout(() => {
        var H = document.body.clientHeight;
        this.zhanshi = H - height1;
      }, 100);
      const that = this;
      window.onresize = () => {
        var H = document.body.clientHeight;
        that.zhanshi = H - height1;
      };
    },
    drawer() {
      if (!this.drawer) {
        this.size = "70%";
        this.a = 2;
        this.formes = {
          agent_id: "",
          fee_id: "",
          app_type: "",
          keywords: "",
          page: "",
          pagesize: 20,
        };
        this.currentPage = 1;
        this.getMainData();
      }
    },
  },
};
</script>

<style lang="less">
.el-tabs--border-card {
  border: 0;
  box-shadow: none;
}
#xiashu .el-dialog__body {
  padding-top: 10px;
  min-height: 600px;
}
</style>
<style lang="less" scoped>
.Success {
  color: #67c23a;
}
.red {
  color: #f56c6c;
}
.especially /deep/.el-input__inner {
  border-radius: 5px 0 0 5px;
}
.especially2 /deep/.el-input__inner {
  border-radius: 0 5px 5px 0;
  border-left: 0;
}
.especially /deep/.el-input__inner:focus {
  border: 1px solid #c0c4cc;
}
.especially2 /deep/.el-input__inner:focus {
  border: 1px solid #c0c4cc;
  border-left: 0;
}
.el-container {
  display: flex;
  flex-direction: column;
}
.el-table /deep/ th {
  padding: 8px 0;
}
.zrss {
  display: flex;
  .moban {
    margin-left: 10px;
    padding: 0px 20px;
    font-size: 14px;
    height: 38px;
    margin-top: 1px;
    line-height: 36px;
  }
}
.nomargin {
  margin: 0 !important;
}
/deep/.el-drawer {
  height: 100% !important;
}
.head {
  height: 81px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 21px;
  .head-l {
    font-size: 18px;
    display: flex;
    align-items: center;
    color: #333333;
    span {
      margin-right: 10px;
      background-color: #409eff;
      color: white;
      font-size: 12px;
      padding: 5px 17px;
      display: block;
      line-height: 11px;
      border-radius: 2px;
    }
  }
  .head-r {
    button {
      background-color: #f2f4fb;
      color: #333333;
      border: none;
      border-radius: 4px;
      margin-right: 12px;
      padding: 7px 16px;
      font-size: 14px;
    }
    span {
      width: 14px;
      height: 14px;
      margin-right: 19px;
      cursor: pointer;
    }
  }
}
.main {
  display: flex;
  flex-direction: column;
  background-color: #f1f1f3;
  padding: 15px 15px;
  height: 100%;

  .detailed {
    background-color: #fff;
    display: flex;
    flex-wrap: wrap;
    padding: 10px 22px;
    div {
      width: 25%;
      color: #666666;
      font-size: 14px;
      line-height: 27px;
      span {
        margin-left: 45px;
        color: #333333;
      }
    }
  }
  .tab-control {
    flex: 1;
    background-color: #fff;
    padding: 0px 20px;
    margin-top: 15px;
    /deep/.el-tabs__nav-wrap {
      height: 50px;
      line-height: 50px;
    }
  }
  /deep/.el-tabs__nav-wrap::after {
    height: 1px !important;
  }
}
</style>
<style lang="less" src="@/assets/css/dialogbox.less" scoped></style>
